import React from "react";
import {
  Leaf,
  Cloud,
  Droplets,
  Tractor,
  BarChart,
  Smartphone,
  Sun,
  MapPin,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Farm Management Systems",
    description:
      "Build comprehensive platforms for farm operations and planning",
    icon: Tractor,
  },
  {
    title: "Precision Agriculture",
    description: "IoT-enabled solutions for smart farming and monitoring",
    icon: MapPin,
  },
  {
    title: "Weather & Climate Tools",
    description: "Integrate weather data for crop planning and risk management",
    icon: Cloud,
  },
  {
    title: "Irrigation Management",
    description: "Smart irrigation systems with automated scheduling",
    icon: Droplets,
  },
  {
    title: "Crop Analytics",
    description: "AI-powered crop health monitoring and yield prediction",
    icon: BarChart,
  },
  {
    title: "Supply Chain Traceability",
    description: "Track produce from farm to fork with blockchain",
    icon: Leaf,
  },
  {
    title: "Farmer Apps",
    description: "Mobile apps for farmers to manage operations on-the-go",
    icon: Smartphone,
  },
  {
    title: "Marketplace Platforms",
    description: "Connect farmers directly with buyers and suppliers",
    icon: Sun,
  },
];

const STATS = [
  { value: "50K+", label: "Farms Connected" },
  { value: "30%", label: "Yield Increase" },
  { value: "40%", label: "Water Savings" },
  { value: "Real-time", label: "Monitoring" },
];

const AgriTechIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="agritech"
      industryTitle="AgriTech"
      industrySubtitle="& Farming"
      heroDescription="Revolutionizing agriculture with smart farming solutions, precision agriculture tools, and farm management systems that increase yields and sustainability."
      themeColor="#84cc16"
      themeColorLight="#a3e635"
      themeGradient="linear-gradient(135deg, #365314 0%, #4d7c0f 50%, #84cc16 100%)"
      HeroIcon={Leaf}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1580982186123-27ab767589aa?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default AgriTechIndustryPage;
